import { gyromagneticRatio } from 'gyromagnetic-ratio';
/**
 * calculate the frequency of a nucleus with respect to a reference nucleus
 */
export function getFrequency(
/**
 * nucleus to calculate the frequency
 */
nucleus, observedNucleusData) {
    const { nucleus: obsNucleus, frequency } = observedNucleusData;
    checkExistence(nucleus, obsNucleus);
    return ((frequency * gyromagneticRatio[nucleus]) /
        gyromagneticRatio[obsNucleus]);
}
function checkExistence(...nucleus) {
    const nuclei = [];
    for (const n of nucleus) {
        if (!(n in gyromagneticRatio)) {
            nuclei.push(n);
        }
    }
    if (nuclei.length !== 0) {
        throw new Error(`${nuclei.join(' , ')} is not supported`);
    }
}
//# sourceMappingURL=getFrequency.js.map